import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MetricsStatsCard } from './MetricsStatsCard';
import type { Metric } from './types';

export const SortableItem = (props: { metric: Metric }) => {
  const {
    // attributes,
    // listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: props.metric.id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="group">
      <MetricsStatsCard metric={props.metric} />
    </div>
  );
};
